// src/apis/api.js
import axios from 'axios';

/**
 * Factory untuk membuat axios instance.
 * - Aman untuk SSR (tidak akses window/localStorage di sini).
 * - Di klien: panggil dengan token dari localStorage.
 * - Di server: panggil per-request (token opsional dari cookie/ctx).
 */
export function createApi({ token, baseURL, headers } = {}) {
    const api = axios.create({
        baseURL:
            baseURL ??
            (import.meta.env?.VITE_API_BASE || 'https://admin.itsyourdayofficial.com/api/'),
        headers: {
            ...(headers || {}),
        },
        // set kalau perlu: withCredentials: true,
    });

    if (token) {
        api.defaults.headers.common.Authorization = `Bearer ${token}`;
    }

    return api;
}

/**
 * Helper khusus KLlEN: lazy singleton membaca token dari localStorage.
 * Jangan dipanggil di server.
 */
let clientApi; // singleton untuk browser
export function getClientApi() {
    if (typeof window === 'undefined') {
        throw new Error('getClientApi() hanya boleh dipanggil di browser');
    }
    if (!clientApi) {
        const token = window.localStorage?.getItem('token') || null;
        clientApi = createApi({ token });
    }
    return clientApi;
}